import { RoutingConstants } from '~/apps/smartsend/lib/consts/RoutingConstants';
import LegacyRoute from '../legacy-route';

// These are legacy routes that redirect to their new equivalents
// Some navigation links will still point to these legacy routes, so we need to keep them working until they can be replaced.
export const legacyRoutes = [
  {
    path: `my-details`,
    element: <LegacyRoute r={RoutingConstants.Settings_Profile} />
  },
  {
    path: `prepay`,
    element: <LegacyRoute r={RoutingConstants.Billing_PrePay} />
  },
  {
    path: `statements-and-invoices`,
    element: <LegacyRoute r={RoutingConstants.Billing_Statements} />
  },
  {
    path: `preferences`,
    element: <LegacyRoute r={RoutingConstants.Settings_CommunicationPreferences} />
  },
  {
    path: `smartsend`,
    element: <LegacyRoute r={RoutingConstants.SmartSend} />
  },
  {
    path: `seller-hub`,
    element: <LegacyRoute r={RoutingConstants.SmartSend} />
  },
  {
    path: 'communication-preferences',
    element: <LegacyRoute r={RoutingConstants.Settings_CommunicationPreferences} />
  }
];
